var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 162,
    viewBox: "0 0 130 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 107.09V56.0266L126.785 67.8991L124.84 104.191L116.461 107.09Z",
    fill: "url(#paint0_linear_32504_60015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0747 124.005V151.681L64.9607 158.908L85.8069 151.681V124.005H44.0747Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3376 124.005V150.053L64.9603 156.526L83.5433 150.053V124.005H46.3376Z",
    fill: "url(#paint1_radial_32504_60015)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8074 124.005V151.681L88.0707 153.27V124.005H85.8074Z",
    fill: "url(#paint2_linear_32504_60015)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8073 151.681V124.005H83.5439V150.053L85.8073 151.681Z",
    fill: "url(#paint3_linear_32504_60015)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.338 150.053V124.005H44.0747V151.681L46.338 150.053Z",
    fill: "url(#paint4_linear_32504_60015)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0751 151.681V124.005H41.8118V153.27L44.0751 151.681Z",
    fill: "url(#paint5_linear_32504_60015)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5944 153.587L64.961 158.908V161.29L49.5944 155.97L41.8118 153.269L44.0751 151.681L49.5944 153.587Z",
    fill: "url(#paint6_linear_32504_60015)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9607 158.908L49.594 153.588L44.0747 151.682L46.338 150.054L49.594 151.205L64.9607 156.526V158.908Z",
    fill: "url(#paint7_linear_32504_60015)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9612 158.908L80.2882 153.587L85.8075 151.681L88.0708 153.269L80.2882 155.97L64.9612 161.29V158.908Z",
    fill: "url(#paint8_linear_32504_60015)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8075 151.682L80.2882 153.588L64.9612 158.908V156.526L80.2882 151.205L83.5441 150.054L85.8075 151.682Z",
    fill: "url(#paint9_linear_32504_60015)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4215 107.09V56.0266L3.09766 67.8991L5.0433 104.191L13.4215 107.09Z",
    fill: "url(#paint10_linear_32504_60015)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4204 83.4647L15.4852 82.075L64.9603 99.1888V101.333L13.4204 83.4647Z",
    fill: "url(#paint11_linear_32504_60015)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 83.4647L114.436 82.075L64.9612 99.1888V101.333L116.461 83.4647Z",
    fill: "url(#paint12_linear_32504_60015)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4204 9.37085L15.4852 11.3562V82.0747L13.4204 83.4645V9.37085Z",
    fill: "url(#paint13_linear_32504_60015)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9614 151.761V101.333L13.4215 83.4643L11.3567 82.7496V133.138L64.9614 151.761Z",
    fill: "url(#paint14_linear_32504_60015)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9612 101.333V151.761L118.526 133.138V82.7496L116.461 83.4643L64.9612 101.333Z",
    fill: "url(#paint15_linear_32504_60015)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9614 149.577L13.4215 131.709L11.3567 133.139L64.9614 151.761V149.577Z",
    fill: "url(#paint16_linear_32504_60015)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 131.709L64.9612 149.577V151.761L118.526 133.139L116.461 131.709Z",
    fill: "url(#paint17_linear_32504_60015)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3567 7.82227V62.3402L3.09766 67.8992L5.0433 104.192L11.3567 106.375V133.138L13.4215 131.709V107.09V84.0204V60.9505V9.37084L11.3567 7.82227Z",
    fill: "url(#paint18_linear_32504_60015)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.403 75.7219L119.122 72.6248V96.052L123.49 93.5107L124.403 75.7219Z",
    fill: "#808080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4849 11.3566V81.9957L64.96 99.1889L114.435 81.9957V11.3566L64.96 4.12988L15.4849 11.3566Z",
    fill: "url(#paint19_radial_32504_60015)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.228 88.5467L103.676 9.80737L114.437 11.356V82.0745L64.9614 99.1883L34.228 88.5467Z",
    fill: "url(#paint20_radial_32504_60015)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7523 17.6696V30.2568L20.9257 28.4303V16.0814L64.961 9.64879L93.4311 13.818V15.6446L64.961 11.4753L22.7523 17.6299V17.6696ZM22.7523 31.5672V54.4782L20.0125 57.218V78.8187L64.9213 94.4236L109.83 78.8187V42.6058L109.751 42.5263L108.917 41.6925L107.09 39.866V17.7094L94.2649 15.8431V13.1033L64.9213 8.81494L20.0125 15.3666V28.8671L22.7523 31.6069V31.5672ZM22.7523 55.7488V76.8334L54.2798 87.7925V89.7382L20.9257 78.1437V57.5754L22.7523 55.7488ZM55.193 88.1102L64.961 91.4853L74.729 88.1102V90.0559L64.961 93.431L55.193 90.0559V88.1102ZM75.6025 87.7925L107.13 76.8334V41.1366L108.957 42.9631V78.1437L75.6025 89.7382V87.7925ZM23.6655 18.4638V76.198L64.961 90.5323L106.256 76.198V18.4638L64.961 12.4283L23.6655 18.4638Z",
    fill: "url(#paint21_radial_32504_60015)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4215 9.3709L64.9614 2.06478V0L11.3567 7.82232L13.4215 9.3709Z",
    fill: "url(#paint22_linear_32504_60015)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9603 2.06494L13.4204 9.37107L15.4852 11.3564L64.9603 4.12972V2.06494Z",
    fill: "url(#paint23_linear_32504_60015)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 9.37085L114.437 11.3562V82.0747L116.462 83.4645V9.37085Z",
    fill: "url(#paint24_linear_32504_60015)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 9.3709L64.9612 2.06478V0L118.526 7.82232L116.461 9.3709Z",
    fill: "url(#paint25_linear_32504_60015)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9612 2.06494L116.461 9.37107L114.436 11.3564L64.9612 4.12972V2.06494Z",
    fill: "url(#paint26_linear_32504_60015)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.869 41.256V15.2875L95.2175 13.1433V15.0096L108.043 16.8758V39.4692L109.869 41.256Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0125 30.0977V55.9073L21.839 54.0411V31.9242L20.0125 30.0977Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9606 91.4855L55.1926 88.0707V90.0163L64.9606 93.3914L74.6889 90.0163V88.0707L64.9606 91.4855Z",
    fill: "url(#paint27_radial_32504_60015)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9612 111.26L63.9685 102.048L22.3157 86.562L64.9612 101.333V111.26Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4205 50.7062L12.6661 9.64899L11.594 8.021L13.5794 8.77544L29.9387 7.02832L13.4205 9.37105V50.7062Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.856 6.19442L64.4054 1.42956L64.9613 0.158936V2.06488L35.856 6.19442Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7308 129.326H103.914V125.356H94.9795V109.949H90.7308V129.326ZM74.8876 129.326H88.3483V125.356H79.1363V121.186H87.1968V117.216H79.1363V113.88H88.3483V109.909H74.8876V129.287V129.326ZM67.0653 129.326L73.2199 110.704V109.076L69.3286 109.393L65.3579 121.305L65.0005 123.33H64.8814L64.524 121.305L60.5533 109.393L56.662 109.076V110.704L62.8166 129.326H67.0256H67.0653ZM41.613 129.326H55.0737V125.356H45.8617V121.186H53.9222V117.216H45.8617V113.88H55.0737V109.909H41.613V129.287V129.326ZM26.0081 129.326H39.1908V125.356H30.2567V109.949H26.0081V129.326Z",
    fill: "#4D5E6E"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7308 127.698H103.914V123.728H94.9795V108.321H90.7308V127.698ZM74.8876 127.698H88.3483V123.728H79.1363V119.558H87.1968V115.588H79.1363V112.252H88.3483V108.281H74.8876V127.659V127.698ZM67.0653 127.698L73.2199 109.076L69.3286 107.765L65.3579 119.677L65.0005 121.702H64.8814L64.524 119.677L60.5533 107.765L56.662 109.076L62.8166 127.698H67.0256H67.0653ZM41.613 127.698H55.0737V123.728H45.8617V119.558H53.9222V115.588H45.8617V112.252H55.0737V108.281H41.613V127.659V127.698ZM26.0081 127.698H39.1908V123.728H30.2567V108.321H26.0081V127.698Z",
    fill: "url(#paint28_linear_32504_60015)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7166 113.007V113.285C16.7166 113.84 17.1533 114.277 17.7092 114.277H20.0917C20.6476 114.277 21.0844 113.84 21.0844 113.285V113.007H16.7166Z",
    fill: "url(#paint29_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1716 112.213H17.6304C17.3524 112.213 17.0745 112.451 17.0745 112.768C17.0745 113.046 17.3127 113.324 17.6304 113.324H20.1716C20.4496 113.324 20.7275 113.086 20.7275 112.768C20.7275 112.49 20.4893 112.213 20.1716 112.213Z",
    fill: "url(#paint30_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7166 118.049V118.327C16.7166 118.883 17.1533 119.32 17.7092 119.32H20.0917C20.6476 119.32 21.0844 118.883 21.0844 118.327V118.049H16.7166Z",
    fill: "url(#paint31_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1716 117.216H17.6304C17.3524 117.216 17.0745 117.454 17.0745 117.772C17.0745 118.05 17.3127 118.328 17.6304 118.328H20.1716C20.4496 118.328 20.7275 118.089 20.7275 117.772C20.7275 117.494 20.4893 117.216 20.1716 117.216Z",
    fill: "url(#paint32_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7166 122.973V123.251C16.7166 123.807 17.1533 124.244 17.7092 124.244H20.0917C20.6476 124.244 21.0844 123.807 21.0844 123.251V122.973H16.7166Z",
    fill: "url(#paint33_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1716 122.179H17.6304C17.3524 122.179 17.0745 122.417 17.0745 122.735C17.0745 123.013 17.3127 123.291 17.6304 123.291H20.1716C20.4496 123.291 20.7275 123.053 20.7275 122.735C20.7275 122.457 20.4893 122.179 20.1716 122.179Z",
    fill: "url(#paint34_linear_32504_60015)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0917 112.014H17.7092C17.1533 112.014 16.7166 112.45 16.7166 113.006C16.7166 113.562 17.1533 113.999 17.7092 113.999H20.0917C20.6476 113.999 21.0844 113.562 21.0844 113.006C21.0844 112.45 20.6476 112.014 20.0917 112.014Z",
    fill: "url(#paint35_linear_32504_60015)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0917 117.057H17.7092C17.1533 117.057 16.7166 117.493 16.7166 118.049C16.7166 118.605 17.1533 119.042 17.7092 119.042H20.0917C20.6476 119.042 21.0844 118.605 21.0844 118.049C21.0844 117.493 20.6476 117.057 20.0917 117.057Z",
    fill: "url(#paint36_linear_32504_60015)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0917 122.02H17.7092C17.1533 122.02 16.7166 122.457 16.7166 123.013C16.7166 123.569 17.1533 124.005 17.7092 124.005H20.0917C20.6476 124.005 21.0844 123.569 21.0844 123.013C21.0844 122.457 20.6476 122.02 20.0917 122.02Z",
    fill: "url(#paint37_linear_32504_60015)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.837 113.007V113.285C108.837 113.84 109.274 114.277 109.83 114.277H112.213C112.768 114.277 113.205 113.84 113.205 113.285V113.007H108.837Z",
    fill: "url(#paint38_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.292 112.213H109.751C109.473 112.213 109.195 112.451 109.195 112.768C109.195 113.046 109.433 113.324 109.751 113.324H112.292C112.57 113.324 112.848 113.086 112.848 112.768C112.848 112.49 112.61 112.213 112.292 112.213Z",
    fill: "url(#paint39_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.837 118.049V118.327C108.837 118.883 109.274 119.32 109.83 119.32H112.213C112.768 119.32 113.205 118.883 113.205 118.327V118.049H108.837Z",
    fill: "url(#paint40_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.292 117.216H109.751C109.473 117.216 109.195 117.454 109.195 117.772C109.195 118.05 109.433 118.328 109.751 118.328H112.292C112.57 118.328 112.848 118.089 112.848 117.772C112.848 117.494 112.61 117.216 112.292 117.216Z",
    fill: "url(#paint41_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.837 122.973V123.251C108.837 123.807 109.274 124.244 109.83 124.244H112.213C112.768 124.244 113.205 123.807 113.205 123.251V122.973H108.837Z",
    fill: "url(#paint42_linear_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.292 122.179H109.751C109.473 122.179 109.195 122.417 109.195 122.735C109.195 123.013 109.433 123.291 109.751 123.291H112.292C112.57 123.291 112.848 123.053 112.848 122.735C112.848 122.457 112.61 122.179 112.292 122.179Z",
    fill: "url(#paint43_linear_32504_60015)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.213 112.014H109.83C109.274 112.014 108.837 112.45 108.837 113.006C108.837 113.562 109.274 113.999 109.83 113.999H112.213C112.768 113.999 113.205 113.562 113.205 113.006C113.205 112.45 112.768 112.014 112.213 112.014Z",
    fill: "url(#paint44_linear_32504_60015)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.213 117.057H109.83C109.274 117.057 108.837 117.493 108.837 118.049C108.837 118.605 109.274 119.042 109.83 119.042H112.213C112.768 119.042 113.205 118.605 113.205 118.049C113.205 117.493 112.768 117.057 112.213 117.057Z",
    fill: "url(#paint45_linear_32504_60015)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.213 122.02H109.83C109.274 122.02 108.837 122.457 108.837 123.013C108.837 123.569 109.274 124.005 109.83 124.005H112.213C112.768 124.005 113.205 123.569 113.205 123.013C113.205 122.457 112.768 122.02 112.213 122.02Z",
    fill: "url(#paint46_linear_32504_60015)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M20.0122 56.384C21.3499 56.384 22.4344 50.393 22.4344 43.0027C22.4344 35.6124 21.3499 29.6213 20.0122 29.6213C18.6745 29.6213 17.5901 35.6124 17.5901 43.0027C17.5901 50.393 18.6745 56.384 20.0122 56.384Z",
    fill: "url(#paint47_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4203 16.0417C14.4924 16.0417 15.3659 20.8463 15.3659 26.7627C15.3659 32.6791 14.4924 37.4836 13.4203 37.4836C12.3482 37.4836 11.4746 32.6791 11.4746 26.7627C11.4746 20.8463 12.3482 16.0417 13.4203 16.0417Z",
    fill: "url(#paint48_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M18.9005 127.937C21.6198 127.937 23.8242 123.546 23.8242 118.129C23.8242 112.712 21.6198 108.321 18.9005 108.321C16.1812 108.321 13.9768 112.712 13.9768 118.129C13.9768 123.546 16.1812 127.937 18.9005 127.937Z",
    fill: "url(#paint49_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M111.022 127.937C113.741 127.937 115.945 123.546 115.945 118.129C115.945 112.712 113.741 108.321 111.022 108.321C108.302 108.321 106.098 112.712 106.098 118.129C106.098 123.546 108.302 127.937 111.022 127.937Z",
    fill: "url(#paint50_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.87 15.1289C110.704 15.1289 111.379 20.9659 111.379 28.1926C111.379 35.4193 110.704 41.2562 109.87 41.2562C109.036 41.2562 108.361 35.4193 108.361 28.1926C108.361 20.9659 109.036 15.1289 109.87 15.1289Z",
    fill: "url(#paint51_radial_32504_60015)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.785 67.8992L118.526 62.3402V7.82227L116.461 9.37084V60.9505V84.0204V107.09V131.709L118.526 133.138V106.375L124.84 104.192L126.785 67.8992Z",
    fill: "url(#paint52_linear_32504_60015)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6387 101.333C70.6387 104.47 68.0975 107.011 64.9606 107.011C61.8237 107.011 59.2825 104.47 59.2825 101.333C59.2825 98.1958 61.8237 95.6545 64.9606 95.6545C68.0975 95.6545 70.6387 98.1958 70.6387 101.333Z",
    fill: "url(#paint53_radial_32504_60015)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47925 75.7219L10.8 72.6248V96.052L6.43221 93.5107L5.47925 75.7219Z",
    fill: "url(#paint54_linear_32504_60015)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86914 76.4758L9.4898 74.9272V93.7882L7.70299 92.7558L6.86914 76.4758Z",
    fill: "url(#paint55_radial_32504_60015)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43188 93.5104L7.70251 92.756L9.48933 93.7884L10.7997 96.0517L6.43188 93.5104Z",
    fill: "url(#paint56_linear_32504_60015)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86899 76.4764L5.47925 75.7219L10.8 72.6248L9.48965 74.9278L6.86899 76.4764Z",
    fill: "url(#paint57_linear_32504_60015)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47925 75.7218L6.86899 76.4762L7.70284 92.7562L6.43221 93.5106L5.47925 75.7218Z",
    fill: "url(#paint58_linear_32504_60015)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4895 93.7887V74.9278L10.7998 72.6248V96.052L9.4895 93.7887Z",
    fill: "url(#paint59_linear_32504_60015)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.403 75.7219L119.122 72.6248V96.052L123.49 93.5107L124.403 75.7219Z",
    fill: "url(#paint60_linear_32504_60015)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.053 76.4758L120.432 74.9272V93.7882L122.179 92.7558L123.053 76.4758Z",
    fill: "url(#paint61_radial_32504_60015)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.49 93.5104L122.179 92.756L120.432 93.7884L119.122 96.0517L123.49 93.5104Z",
    fill: "url(#paint62_linear_32504_60015)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.053 76.4764L124.403 75.7219L119.122 72.6248L120.432 74.9278L123.053 76.4764Z",
    fill: "url(#paint63_linear_32504_60015)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.403 75.7218L123.053 76.4762L122.179 92.7562L123.489 93.5106L124.403 75.7218Z",
    fill: "url(#paint64_linear_32504_60015)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.432 93.7887V74.9278L119.122 72.6248V96.052L120.432 93.7887Z",
    fill: "url(#paint65_linear_32504_60015)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13999 64.564C12.6269 64.564 16.28 73.4187 16.28 84.3779C16.28 95.337 12.6269 104.192 8.13999 104.192C3.65307 104.192 0 95.337 0 84.3779C0 73.4187 3.65307 64.564 8.13999 64.564Z",
    fill: "url(#paint66_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.743 64.5641C126.23 64.5641 129.883 73.4188 129.883 84.378C129.883 95.3372 126.23 104.192 121.743 104.192C117.256 104.192 113.603 95.3372 113.603 84.378C113.603 73.4188 117.256 64.5641 121.743 64.5641Z",
    fill: "url(#paint67_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M9.21156 124.641C10.1545 124.641 10.919 106.596 10.919 84.3377C10.919 62.0791 10.1545 44.0349 9.21156 44.0349C8.26858 44.0349 7.50415 62.0791 7.50415 84.3377C7.50415 106.596 8.26858 124.641 9.21156 124.641Z",
    fill: "url(#paint68_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M7.30555 64.1665C7.70262 64.1665 8.02028 73.2197 8.02028 84.3377C8.02028 95.4558 7.70262 104.509 7.30555 104.509C6.90848 104.509 6.59082 95.4558 6.59082 84.3377C6.59082 73.2197 6.90848 64.1665 7.30555 64.1665Z",
    fill: "url(#paint69_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M120.67 124.68C121.623 124.68 122.377 106.614 122.377 84.3776C122.377 62.1416 121.623 44.0748 120.67 44.0748C119.717 44.0748 118.963 62.1416 118.963 84.3776C118.963 106.614 119.717 124.68 120.67 124.68Z",
    fill: "url(#paint70_radial_32504_60015)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M122.615 64.1671C122.218 64.1671 121.901 73.2203 121.901 84.3384C121.901 95.4564 122.218 104.51 122.615 104.51C123.012 104.51 123.33 95.4564 123.33 84.3384C123.33 73.2203 123.012 64.1671 122.615 64.1671Z",
    fill: "url(#paint71_radial_32504_60015)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1454 36.0949L69.369 35.261L69.5278 35.4596L67.2645 36.8096L56.8612 45.982V54.0822H70.3617L72.8633 56.6235V60.4751L70.3617 63.056H58.2113L50.111 60.2766L47.0933 69.2107L56.345 72.3475H74.5707L82.7901 64.2076V53.566L74.5707 45.3864H71.4338L69.1705 46.2202L69.0513 46.0217L71.3146 44.7113L82.7901 34.6257V26.7637H48.5227V36.0949H67.1454Z",
    fill: "url(#paint72_linear_32504_60015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32504_60015",
    x1: 116.461,
    y1: 81.5583,
    x2: 126.785,
    y2: 81.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B3840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204954"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9603 156.526) scale(19.4565 19.4565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B0FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9CFFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#89FFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#71FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#53FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#30FFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#08FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32504_60015",
    x1: 85.8074,
    y1: 138.618,
    x2: 88.0707,
    y2: 138.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32504_60015",
    x1: 83.5439,
    y1: 137.823,
    x2: 85.8073,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32504_60015",
    x1: 44.0747,
    y1: 137.823,
    x2: 46.338,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32504_60015",
    x1: 41.8118,
    y1: 138.618,
    x2: 44.0751,
    y2: 138.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32504_60015",
    x1: 41.8118,
    y1: 156.486,
    x2: 64.961,
    y2: 156.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32504_60015",
    x1: 44.0747,
    y1: 154.501,
    x2: 64.9607,
    y2: 154.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32504_60015",
    x1: 64.9612,
    y1: 156.486,
    x2: 88.0708,
    y2: 156.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32504_60015",
    x1: 64.9612,
    y1: 154.501,
    x2: 85.8075,
    y2: 154.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32504_60015",
    x1: 3.09766,
    y1: 81.5583,
    x2: 13.4215,
    y2: 81.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32504_60015",
    x1: 13.4204,
    y1: 91.7238,
    x2: 64.9603,
    y2: 91.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32504_60015",
    x1: 64.9612,
    y1: 91.7238,
    x2: 116.461,
    y2: 91.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32504_60015",
    x1: 13.4204,
    y1: 46.4177,
    x2: 15.4852,
    y2: 46.4177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_32504_60015",
    x1: 64.6437,
    y1: 101.491,
    x2: 7.94188,
    y2: 135.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A94C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_32504_60015",
    x1: 64.5641,
    y1: 101.055,
    x2: 120.392,
    y2: 134.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42689C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_32504_60015",
    x1: 11.3567,
    y1: 141.715,
    x2: 64.9614,
    y2: 141.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32504_60015",
    x1: 64.9612,
    y1: 141.715,
    x2: 118.526,
    y2: 141.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32504_60015",
    x1: 3.09766,
    y1: 70.4802,
    x2: 13.4215,
    y2: 70.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.96 4.16959) scale(95.3767 95.3767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#01429F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#033082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#042571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05226B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#091D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1C4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7034 -14.692) scale(126.189 126.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9978 15.7637) scale(127.778 127.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_32504_60015",
    x1: 11.3567,
    y1: 4.68545,
    x2: 64.9614,
    y2: 4.68545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7996B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_32504_60015",
    x1: 13.4204,
    y1: 6.71068,
    x2: 64.9603,
    y2: 6.71068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_32504_60015",
    x1: 114.437,
    y1: 46.4177,
    x2: 116.462,
    y2: 46.4177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_32504_60015",
    x1: 64.9612,
    y1: 4.68545,
    x2: 118.526,
    y2: 4.68545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E76A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_32504_60015",
    x1: 64.9612,
    y1: 6.71068,
    x2: 116.461,
    y2: 6.71068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9606 90.7311) scale(9.56944 9.56941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_32504_60015",
    x1: 64.9608,
    y1: 127.698,
    x2: 64.9608,
    y2: 107.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_32504_60015",
    x1: 18.9005,
    y1: 114.277,
    x2: 18.9005,
    y2: 113.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_32504_60015",
    x1: 18.901,
    y1: 113.285,
    x2: 18.901,
    y2: 112.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_32504_60015",
    x1: 18.9005,
    y1: 119.28,
    x2: 18.9005,
    y2: 118.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#283B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1D6073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#14809E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0D9AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#07AEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#03BCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_32504_60015",
    x1: 18.901,
    y1: 118.328,
    x2: 18.901,
    y2: 117.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_32504_60015",
    x1: 18.9005,
    y1: 124.244,
    x2: 18.9005,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_32504_60015",
    x1: 18.901,
    y1: 123.251,
    x2: 18.901,
    y2: 122.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_32504_60015",
    x1: 18.9005,
    y1: 113.999,
    x2: 18.9005,
    y2: 112.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_32504_60015",
    x1: 18.9005,
    y1: 119.002,
    x2: 18.9005,
    y2: 117.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_32504_60015",
    x1: 18.9005,
    y1: 123.966,
    x2: 18.9005,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_32504_60015",
    x1: 111.021,
    y1: 114.277,
    x2: 111.021,
    y2: 113.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_32504_60015",
    x1: 111.022,
    y1: 113.285,
    x2: 111.022,
    y2: 112.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_32504_60015",
    x1: 111.021,
    y1: 119.28,
    x2: 111.021,
    y2: 118.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_32504_60015",
    x1: 111.022,
    y1: 118.328,
    x2: 111.022,
    y2: 117.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_32504_60015",
    x1: 111.021,
    y1: 124.244,
    x2: 111.021,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_32504_60015",
    x1: 111.022,
    y1: 123.251,
    x2: 111.022,
    y2: 122.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_32504_60015",
    x1: 111.021,
    y1: 113.999,
    x2: 111.021,
    y2: 112.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_32504_60015",
    x1: 111.021,
    y1: 119.002,
    x2: 111.021,
    y2: 117.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_32504_60015",
    x1: 111.021,
    y1: 123.966,
    x2: 111.021,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.45335 44.0319) rotate(-90) scale(13.2558 2.20931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.57481 27.9746) rotate(-90) scale(10.6256 1.77095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0057 118.306) rotate(-90) scale(9.74017 4.87008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.878 118.306) rotate(-90) scale(9.74017 4.87009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.936 26.6091) rotate(-90) scale(13.2559 1.65699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_32504_60015",
    x1: 116.461,
    y1: 70.4802,
    x2: 126.785,
    y2: 70.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9606 101.333) scale(5.67813 5.67812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1798C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#127498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0D556F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#093B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#052530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#01090B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#000202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_32504_60015",
    x1: 8.13962,
    y1: 72.6645,
    x2: 8.13962,
    y2: 96.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.17947 84.3776) scale(6.71047 6.71052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_32504_60015",
    x1: 8.61578,
    y1: 92.756,
    x2: 8.61578,
    y2: 96.0914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_32504_60015",
    x1: 8.13962,
    y1: 72.6645,
    x2: 8.13962,
    y2: 76.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_32504_60015",
    x1: 6.59104,
    y1: 75.7615,
    x2: 6.59104,
    y2: 93.5503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_32504_60015",
    x1: 10.1248,
    y1: 72.6645,
    x2: 10.1248,
    y2: 96.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_32504_60015",
    x1: 121.743,
    y1: 72.6645,
    x2: 121.743,
    y2: 96.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.743 84.3776) rotate(180) scale(6.71055 6.71052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_32504_60015",
    x1: 121.306,
    y1: 92.756,
    x2: 121.306,
    y2: 96.0914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_32504_60015",
    x1: 121.743,
    y1: 72.6645,
    x2: 121.743,
    y2: 76.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_32504_60015",
    x1: 123.291,
    y1: 75.7615,
    x2: 123.291,
    y2: 93.5503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_32504_60015",
    x1: 119.757,
    y1: 72.6645,
    x2: 119.757,
    y2: 96.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6954 82.8821) rotate(-90) scale(20.2439 8.33574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.96 82.8822) rotate(-90) scale(20.2439 8.33573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8641 84.9591) rotate(-90) scale(40.2798 1.6415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-175.276 83.3848) rotate(90) scale(20.1315 0.805263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.9507 84.9593) rotate(-90) scale(40.2798 1.6415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_32504_60015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367.93 83.3854) rotate(90) scale(20.1315 0.805263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_32504_60015",
    x1: 81.9959,
    y1: 65.0414,
    x2: 46.1403,
    y2: 29.1858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3);
export default __webpack_public_path__ + "static/media/level3.7b9c8aa07de109d1af7c1302f9b644af.svg";
export { ForwardRef as ReactComponent };